import { FC } from 'react';

import { Attachment } from 'utils/types';
import { SIZE } from 'utils/constants';

import UploadedListItem from './UploadedListItem';

interface PROPS {
  attachments: Attachment[];
  showRemove?: boolean;
  onRemove: (id: string) => void;
  onDownload: (uri: string, name: string) => void;
  isEditing: boolean;
}

const UploadItemsList: FC<PROPS> = ({
  attachments,
  onRemove,
  onDownload,
  isEditing,
}) => {
  if (!attachments.length) return null;
  return (
    <div className="flex gap-x-[6px] overflow-x-auto pb-2">
      {attachments.map((attachment) => (
        <UploadedListItem
          key={attachment._id}
          file={attachment}
          isEditing={isEditing}
          size={SIZE.Small}
          onRemove={() => onRemove(attachment._id as string)}
          onDownload={() => onDownload(attachment.fileUrl, attachment.fileName)}
        />
      ))}
    </div>
  );
};

export default UploadItemsList;
